import { Coordinates } from '../core/api/general/general.types';
import * as Api from './Api';

export interface GoogleTools {
  AutoComplete: google.maps.places.AutocompleteService;
  GeoCoder: google.maps.Geocoder;
}

export interface Config {
  DeviceId: string;
  IncludePhysicalRestaurantIds: string;
  showRestaurantList: boolean;
}

export const LatLng = (Geo: Coordinates): google.maps.LatLng =>
  new google.maps.LatLng(Geo.Latitude, Geo.Longitude);

export const ToGeo = (p: google.maps.LatLng): Coordinates => ({
  Latitude: p.lat(),
  Longitude: p.lng(),
});

export const DefaultPaymentAccount = function (
  asyncAccounts: Async<Api.PaymentAccount[]>,
): Api.PaymentAccount | null {
  const { status } = asyncAccounts;
  if (status !== 'success') {
    return null;
  }

  const { data: accounts } = asyncAccounts;
  if (accounts.length < 1) {
    return null;
  }

  let defaultAccount = accounts.filter((p) => p.IsDefaultPaymentMethod)[0];

  if (!defaultAccount) {
    // Raven.captureMessage(
    //   'user has no default payment account - using first account',
    // );
    defaultAccount = accounts[0];
  }

  return defaultAccount;
};

// #region ! Deprecated - use Async from src/core/types/data.types.d.ts
interface None {
  status: 'none';
  error?: string | Error;
}

interface Pending {
  status: 'pending';
}

interface Loaded<T> {
  status: 'success';
  data: T;
}

export type Async<T> = Pending | None | Loaded<T>;
// #endregion
